import { gql } from '@apollo/client'

export const ADD_RATES = gql`
  mutation AddRatesMutation($rates: [Rate], $suggestions: String) {
    addRates(portal: "psp", rates: $rates, suggestions: $suggestions) {
      success
    }
  }
`
